import { AlertCircle } from "lucide-react";
import { useOpsHealth } from "@/hooks/useOpsHealth";

/**
 * Sticky critical-count chip that lives in the Admin header next to "Lab control".
 *
 * Clicking it dispatches the same `admin-switch-tab` event used by the
 * OpsHealthWidget rows, taking the user back to the Dashboard tab where the
 * full feed lives. Hides entirely when `critical = 0` so the header stays
 * clean on a healthy day.
 *
 * Polls every 60 s via the shared `useOpsHealth` hook — same single network
 * request the widget already makes, so the badge is essentially free.
 */
export default function OpsCriticalBadge() {
    const { counts } = useOpsHealth();
    const critical = counts?.critical || 0;
    if (critical < 1) return null;
    const handleClick = () => {
        window.dispatchEvent(new CustomEvent("admin-switch-tab", { detail: { tabId: "dashboard" } }));
    };
    return (
        <button
            type="button"
            onClick={handleClick}
            data-testid="ops-critical-badge"
            title={`${critical} critical item${critical === 1 ? "" : "s"} need attention`}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-700 text-[11.5px] font-medium transition-colors"
        >
            <AlertCircle size={12} />
            <span>{critical}</span>
            <span className="hidden sm:inline">critical</span>
        </button>
    );
}
